<template>
    <div class="storeDecorate-container">
        <div class="storeSign-upload">
            <div class="storeSign-img">
                <img :src="dzInfo.img_url ? dzInfo.img_url : require('../../../../assets/images/noimg.png')" alt="">
            </div>
            <el-upload class="upload-demo"
                       action="stuOp/dzPosterUploadImg"
                       :headers="headersParams"
                       name="image"
                       :data="{type: 1}"
                       :show-file-list="false"
                       :on-success="handleCoverSuccess"
                       :before-upload="beforeCoverUpload">
                <el-button icon="el-icon-upload2" style="width: 248px; margin-top: 20px" type="primary" plain>点击上传</el-button>
            </el-upload>
        </div>
        <div class="storeSign-prompt">
            <i class="iconfont">&#xe72a;</i>
            <span class="title">提示</span>上传尺寸为1920px*120px，仅支持jpg、jpeg、png格式,每张图片小于等于2M
        </div>
        <div style="height: 1%; flex: 1"></div>
        <div class="storeSign-btn">
            <el-button type="primary" @click="submitBtn()">提交</el-button>
        </div>
    </div>
</template>

<script>
    import { stuOpSaveDzAndPposter, stuOpDzPosterList } from '@/utils/apis.js'
    export default {
        name: "PageSetDZ",
        data() {
            return {
                hostUrl:localStorage.getItem('hosturl') || '',
                dzInfo: {
                    img_url: '', // 无域名 表单提交
                    // img: '', // 有域名
                },

                // S 上传图片需要
                uploadCover: '',
                headersParams: {
                    Authorization: localStorage.getItem('studentToken') || ''
                },
                // E 上传图片需要
            };
        },
        mounted() {
            this.getDianzhaoInfo()
        },
        methods: {
            // 获取店招信息
            getDianzhaoInfo() {
                stuOpDzPosterList({type: 1}).then((res) => {
                    this.dzInfo.img_url = res.data.url
                }).catch((err) => {})
            },
            // start 上传图片
            beforeCoverUpload(file) {
                const isImg = file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.png');
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isImg) {
                    this.$message.error('上传图片只能是 jpg 或 jpeg 或 png 格式!');
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                    return false;
                }
                return isImg && isLt2M;
            },
            handleCoverSuccess(res, file) {
                if (res.code === 200) {
                    this.dzInfo.img_url = res.data // 无域名
                    // this.dzInfo.img = this.hostUrl + res.data // 有域名
                    this.$message.success('上传店招成功')
                } else {
                    this.$message.error(res.msg)
                }
            },
            // end 上传图片
            // 提交
            submitBtn() {
                if (!this.dzInfo.img_url) {
                    this.$message.warning('请上传店招')
                    return false
                }

                let formData = new FormData()
                formData.append('type', '1')
                formData.append('url', this.dzInfo.img_url)
                let params = {
                    type: 1,
                    url: this.dzInfo.img_url
                }

                stuOpSaveDzAndPposter(params).then((res) => {
                    this.$message.success(res.msg)
                    this.getDianzhaoInfo()
                }).catch((err) => {})
            },
        }
    }
</script>

<style scoped lang="scss">
    .mask-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        /*background: rgba(255, 255, 255, .5);*/
        display: flex;
        align-items: center;
        justify-content: center;
        .prompt {
            color: #fff;
            font-size: 30px;
            .iconfont {
                font-size: 30px;
                margin-right: 10px;
            }
        }
    }
    .storeDecorate-container {
        background: #fff;
        min-height: calc(100vh - 120px);
        box-sizing: border-box;
        padding: 30px 90px 50px;
        display: flex;
        flex-direction: column;
        .storeSign-upload {
            .storeSign-img {
                width: 100%;
                height: 0;
                padding-bottom: 6.25%;
                position: relative;
                background: #fafafa;
                img {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
        .storeSign-prompt {
            color: #999;
            margin-top: 20px;
            min-height: 45px;
            border: 1px solid #DCDCDC;
            line-height: 21px;
            padding: 10px 20px;
            box-sizing: border-box;
            .iconfont {
                color: #FF0000;
            }
            .title {
                color: #333;
                margin: 0 20px;
            }
        }
        .storeSign-btn {
            text-align: center;
        }
    }
</style>